import { atom, useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";

import { WorkScheduleConfigJsonType } from "../types/types";

const isDarkModeAtom = atomWithStorage<boolean>("isDarkMode", false);
export const useIsDarkMode = () => useAtom(isDarkModeAtom);

const dayStartChangedAtom = atom<boolean>(true);
export const useDayStartChanged = () => useAtom(dayStartChangedAtom);

const isLotInfoPausedAtom = atom<boolean>(false);
export const useIsLotInfoPaused = () => useAtom(isLotInfoPausedAtom);

const highlightOverlappingSegmentsAtom = atom<boolean>(false);
export const useHighlightOverlappingSegments = () =>
  useAtom(highlightOverlappingSegmentsAtom);

const forceMidgardBreakerOpenAtom = atom<boolean>(false);
export const useForceMidgardBreakerOpen = () =>
  useAtom(forceMidgardBreakerOpenAtom);

const customerHasCountsAtom = atom<boolean>(false);
export const useCustomerHasCounts = () => useAtom(customerHasCountsAtom);

const workScheduleConfigJsonListAtom = atomWithStorage<
  WorkScheduleConfigJsonType[]
>("workScheduleConfigJsonListAtom", [] as WorkScheduleConfigJsonType[]);
export const useWorkScheduleConfigJsonListAtom = () =>
  useAtom(workScheduleConfigJsonListAtom);

const wasLastPageOperatorPageAtom = atom<boolean>(false);
export const useWasLastPageOperatorPage = () =>
  useAtom(wasLastPageOperatorPageAtom);
